import type React from 'react';
import type { Box } from '@withjoy/joykit';
import { cssTransitionAnimation } from './drawerCssAnimation';
import { springAnimation } from './drawerSpringAnimation';

export type DrawerAnimationStyle = Readonly<{
  transform?: string;
  transition?: string;
  willChange: 'transform';
}>;

export type UseDrawerAnimationParams = Readonly<{
  isOpen: boolean;
  openPositionVh: number;
  openPositionOffsetPx: number;
  closedHeightPx: number;
}>;

export type DrawerAnimationResult = Readonly<{
  Wrapper: React.ComponentType<React.ComponentProps<typeof Box>>;
  useAnimation: (args: UseDrawerAnimationParams) => DrawerAnimationStyle;
  baseProps: typeof DRAWER_WRAPPER_BASE_PROPS;
}>;

export const DRAWER_WRAPPER_BASE_PROPS = {
  id: 'DrawerWrapper',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  pointerEvents: 'auto',
} as const;

type AnimationType = 'css' | 'spring';

export const createDrawerAnimation = (animationType: AnimationType): DrawerAnimationResult => {
  if (animationType === 'spring') {
    return {
      Wrapper: springAnimation.Wrapper,
      useAnimation: springAnimation.useAnimation,
      baseProps: DRAWER_WRAPPER_BASE_PROPS,
    };
  }

  return {
    Wrapper: cssTransitionAnimation.Wrapper,
    useAnimation: cssTransitionAnimation.useAnimation,
    baseProps: DRAWER_WRAPPER_BASE_PROPS,
  };
};
